<template>
  <div
    :id="`Hero1-${pageUid}`"
    :class="`c-${textColor} bg-${backgroundColor}`"
    class="hero hero1 hero--1 lp-section hero-container width-expand relative">
    <div style="min-height: 450px" class="hero-inner">
      <div
        class="hero-content-wrapper flex-stretch flex-end l:padding-l"
        style="flex: 50%">
        <div class="hero-content flex-middle">
          <div class="hero-content-inner" style="width: 100%">

            <div class="logo" v-if="logo.show">
              <anchor
                v-if="logo.show"
                :href="sanitizeLink(logo.href)"
                :target="logo.target"
                class="logo inline-block logo logo--1 flex-middle object-contain"
                @click.prevent="
                  track('hero1|logo|click').then(logo.navigationHandler)
                ">
                <img class="img" :alt="logo.alt" :src="logo.finalSrc" />
              </anchor>
            </div>
            <div class="live-logo flex-middle flex-center l:flex-start width-expand" v-if="showLiveTextLogo">
              <span class="company-name" :class="`c-${titleColor}`">מיטב</span>
              <span
                class="company-separator"
                :class="`c-${companySeparatorColor}`"
                >:</span
              >
              <span class="company-text" :class="`c-${textColor}`">{{
                logoText
              }}</span>
            </div>
            <div class="texts">
              <h1
                v-if="isNonEmptyString(title)"
                class="hero-h1"
                v-html="textToSafeHtml(title)"
                :class="`c-${titleColor}`"></h1>
              <h2
                class="hero-h2 margin-s-bottom"
                v-html="textToSafeHtml(subTitle)"></h2>
              <p class="hero-text" v-html="textToSafeHtml(text)"></p>
            </div>

            <div class="buttons" v-if="button.show || button2.show">
              <form-button
                v-show="button.show"
                class=""
                v-bind="button"
                :auto-translate="false"
                @click="
                  track('hero1|button1|click', { value: button.text }).then(
                    button.navigationHandler
                  )
                "></form-button>
              <form-button
                v-show="button2.show"
                class=""
                v-bind="button2"
                :auto-translate="false"
                @click="
                  track('hero1|button2|click', { value: button2.text }).then(
                    button2.navigationHandler
                  )
                "></form-button>
            </div>

            <div
              class="cta-link flex-middle gap-s margin-m-top text-l text-bold"
              v-if="isNonEmptyString(ctaIconLink.text)">
              <span
                class="inline-block"
                v-if="isNonEmptyString(ctaTextPrefix)"
                >{{ ctaTextPrefix }}</span
              >
              <a
                class="hero-cta-link"
                :href="ctaIconLink.href"
                :class="`c-${ctaLinkColor}`"
                @click.prevent="
                  track('hero1|ctaLink|click', {
                    value: ctaIconLink.text,
                  }).then(ctaIconLink.navigationHandler)
                ">
                <icon-text v-bind="ctaIconLink"></icon-text>
              </a>
            </div>

            <div
              class="separator width-expand margin-l-top"
              style="height: 3px"
              :class="`bg-${textColor}`"
              v-if="showCtaSeparator"></div>

            <div
              class="video-controls flex-middle gap-s margin-l-top"
              v-if="videoId">
              <span v-if="isNonEmptyString(videoTextPrefix)">{{
                videoTextPrefix
              }}</span>

              <icon-halo
                style="transform: scale(-1, -1); padding-inline-end: 3px"
                :size="1.2"
                class="cursorPointer"
                @click.prevent="
                  track('hero1|videoCta|click}', {
                    value: ctaIconLink.videoCtaText,
                  }).then(playVideo)
                "
                icon="mc-play"
                :halo-theme="titleColor"
                :theme="textColor"></icon-halo>
              <a
                href="#"
                @click.prevent="
                  track('hero1|videoCta|click}', {
                    value: ctaIconLink.videoCtaText,
                  }).then(playVideo)
                "
                class="cursor-pointer"
                v-if="isNonEmptyString(videoCtaText)"
                >{{ videoCtaText }}</a
              >
            </div>
            <youtube-video-modal
              v-if="!$s.isCrawler"
              ref="videoModal"
              size="auto"
              :show="false"
              :video-id="videoId"
              :auto-play="true"></youtube-video-modal>
          </div>
        </div>
      </div>
      <div
        class="image-separator"
        :class="`bg-${imageSeparatorColor}`"
        style="flex: 3px"></div>
      <div
        class="hero-image flex-middle flex-center"
        :style="`background-image: url('${image.finalSrc}');`"
        style="flex: 50%"></div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject, computed } from "vue";

export default {
  mixins: [lpSectionMixin],
  setup: function (props) {
    let pageUid = inject("pageUid");

    let schema = {
      image: {},
      logo: {},
      showLiveTextLogo: true,
      logoText: "",
      title: "",
      subTitle: "",
      text: "",
      button: {},
      button2: {},
      showCtaSeparator: false,
      ctaTextPrefix: "",
      ctaIconLink: {},
      videoTextPrefix: "",
      videoCtaText: "",
      videoId: "",
      allData: {},
      backgroundColor: "",
      titleColor: "",
      textColor: "",
      imageSeparatorColor: "",
      companySeparatorColor: "lead",
      ctaLinkColor: "",
      trackEvent: () => {},
      track: () => {},
      triggerSectionsEvent: () => {},
      pageUid,
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    playVideo() {
      try {
        console.log(this.$refs["videoModal"]);
        this.$refs["videoModal"].showModal();
      } catch (e) {
        console.log("error");
        console.log(e);
      }
    },
  },
  mounted() {

  },
};
</script>

<style scoped lang="scss">
.hero1 {
  .hero-inner {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: center;

    @media (max-width: 1150px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .hero-content-wrapper {
    flex: 0 0 calc(50% - 1px);
    line-height: 1.1;

    @media (max-width: 1150px) {
      order: 3;
      text-align: center;
    }

    .hero-content {
      width: 100%;
      max-width: 980px;
      padding-block: var(--margin-xl);
      padding-inline: var(--margin-l);

      @media (max-width: 768px) {
        padding-inline: var(--margin-m);
      }
    }

    .hero-content-inner {
      max-width: 750px;
    }
  }

  .live-logo {
    font-size: calc(var(--font-max) * 1.1);

    @media (max-width: 500px) {
      font-size: calc(var(--font-max) * 0.85);
    }

    .company-name {
      font-weight: bold;
    }

    .company-separator {
      font-weight: 900;
      font-size: calc(var(--font-max) * 1.5);

      @media (max-width: 500px) {
        font-size: calc(var(--font-max) * 1.1);
      }
    }

    .company-text {
      margin-inline-start: var(--margin-s);

      @media (max-width: 400px) {
        margin-inline-start: var(--margin-xs);
      }
    }
  }

  .hero-h1 {
    line-height: 0.8;
    font-size: calc(var(--font-jumbo) * 1.2);
    font-weight: bold;
    margin-bottom: var(--margin-2xl);

    @media (max-width: 1150px) {
      line-height: 0.7;
      font-size: calc(var(--font-jumbo) * 0.75);
      margin-bottom: var(--margin-xl);
    }

    @media (max-width: 767px) {
      line-height: 0.85;
    }

    @media (max-width: 500px) {
      font-size: calc(var(--font-jumbo) * 0.70);
      margin-bottom: var(--margin-xl);
    }
  }

  .hero-h2 {
    line-height: 1;
    font-size: calc(var(--font-2xl) * 1.2);
    font-weight: bold;
    margin-bottom: var(--margin-s);

    @media (max-width: 1150px) {
      line-height: 0.85;
      font-size: calc(var(--font-2xl) * 1);
    }
  }

  .hero-text {
    line-height: 1;
    font-size: calc(var(--font-2xl) * 1);

    @media (max-width: 1150px) {
      line-height: 1;
      font-size: calc(var(--font-2xl) * 0.9);
    }
  }

  .buttons {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--margin-l);
    margin-top: var(--margin-2xl);

    @media (max-width: 1150px) {
      margin-top: var(--margin-xl);
      justify-content: center;
    }
  }

  .cta-link {
    font-size: calc(var(--font-xl) * 1);

    @media (max-width: 1150px) {
      margin-top: var(--margin-xl);
      justify-content: center;
      font-size: calc(var(--font-xl) * 0.9);
    }
  }

  .separator {
    @media (max-width: 1150px) {
      max-width: 85%;
      margin-inline: auto;
    }
  }

  .video-controls {
    font-size: calc(var(--font-xl) * 1);

    @media (max-width: 1150px) {
      margin-top: var(--margin-xl);
      justify-content: center;
    }
  }

  .image-separator {
    @media (max-width: 1150px) {
      order: 2;
      flex: 3px;
      width: 100%;
      height: 3px;
      max-height: 3px;
    }
  }

  .hero-image {
    background-size: cover;
    background-position-x: right;
    background-position-y: center;
    flex: 0 0 calc(50% - 1px);

    @media (max-width: 1150px) {
      order: 1;
      min-height: 200px;
      width: 100%;
      background-position-x: center;
      background-position-y: bottom;
    }
  }
}
</style>
